<script lang="ts">
	import { currentLanguage } from '$lib/stores/i18n';
	import HomePage from '../+page.svelte';
	import { getLanguageFromPath, t } from '$lib/stores/i18n';
	import { page } from '$app/stores';

	export let data: { lang?: string };

	// Set language from route parameter
	$: if (data?.lang) {
		currentLanguage.set(data.lang as 'en' | 'th');
	}
	$: lang = data?.lang || getLanguageFromPath($page.url.pathname) || 'en';
</script>

<svelte:head>
	<title>{$t('meta.title')}</title>
	<meta name="description" content={$t('meta.description')} />
	<meta name="keywords" content="3d ai, 3dai, 3dai.co.th, {$t('meta.keywords')}" />
	<meta name="robots" content="index, follow" />
	<meta property="og:type" content="website" />
	<meta property="og:title" content={$t('meta.title')} />
	<meta property="og:description" content={$t('meta.description')} />
	<meta property="og:url" content="https://3dai.co.th/{lang}" />
	<meta property="og:site_name" content="3DAI" />
	<meta property="og:locale" content={lang === 'th' ? 'th_TH' : 'en_US'} />
</svelte:head>

<HomePage />
